import type { SessionStatus } from '@web/api/types'

export { ACTIVE_STATUSES, groupSessions } from '@web/state/session-order'

export function statusTone(
  status: SessionStatus,
): 'ok' | 'warn' | 'accent' | 'danger' | 'faint' {
  switch (status) {
    case 'ready':
    case 'idle':
      return 'ok'
    case 'starting':
    case 'requires_action':
    case 'detached':
      return 'warn'
    case 'running':
      return 'accent'
    case 'error':
      return 'danger'
    default:
      return 'faint'
  }
}
